import type { SvgType } from './types'

export default function Flag({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M8.493 4C7.663 4 6 4.281 6 4.281v15.47a.75.75 0 001.5 0v-7.944a19.66 19.66 0 011.632.059c.848.066 1.717.315 2.583.563 1.002.286 2 .571 2.952.571C16.24 13 18 12.156 18 12.156V4s-1.922 1.125-3.438 1.125c-1.011 0-2.023-.281-3.034-.563C10.516 4.282 9.505 4 8.493 4z"
        clipRule="evenodd"
      />
    </svg>
  )
}
